<ng-container *ngFor="let recommendation of recommendations">
  <ng-container *ngIf="!recommendation.url">
    <div class="recommendation">
      <div class="thumb-container">
        <div class="thumb" [responsiveBackgroundImage]="recommendation.thumbnail">
          <div class="all-done" *ngIf="!recommendation.thumbnail">
            <img src="/assets/community/recommended-check.svg" alt="Check mark" />
          </div>
        </div>
      </div>
      <div class="details">
        <div class="info">
          <div class="title">{{recommendation.title}}</div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="recommendation.url">
    <a href="{{recommendation.url}}" class="recommendation">
      <div class="thumb-container">
        <div class="thumb"
          [responsiveBackgroundImage]="recommendation.thumbnail || '/assets/flag-backdrop.png'"></div>
        <div class="status" *ngIf="recommendation.status">
          {{recommendation.status}}
        </div>
      </div>
      <div class="details">
        <div class="info">
          <div class="title">{{recommendation.title}}</div>
        </div>
        <div class="facts-container">
          <ul class="facts">
            <li *ngFor="let fact of asArray(recommendation.facts)">{{fact}}</li>
          </ul>
        </div>
      </div>
    </a>
  </ng-container>
</ng-container>